The input parameter for the `positionNotPostedReasons` query.
